import { Clock } from "lucide-react";

/**
 * Shadcn-styled time picker.
 *
 * Wraps the native <input type="time"> in a Shadcn outline-style shell so it
 * visually matches DatePicker / CustomerCombobox across every stage form.
 * We keep the native picker underneath because it is the most reliable
 * cross-browser/mobile time input — but hide its default clock icon so only
 * our lucide Clock icon is shown.
 *
 * @param value    "HH:MM" string or ""
 * @param onChange Called with the raw "HH:MM" string
 * @param testId   data-testid for the input
 * @param disabled Disables the input
 */
export default function TimePicker({ value, onChange, testId, disabled }) {
  return (
    <div className={`h-9 w-full flex items-center gap-2 rounded-sm border border-neutral-300 bg-white px-3 text-sm ${
      disabled ? "opacity-60 cursor-not-allowed" : "focus-within:ring-1 focus-within:ring-[#FF5A00] focus-within:border-[#FF5A00]"
    }`}>
      <Clock size={14} className="text-neutral-500 shrink-0" />
      <input
        type="time"
        data-testid={testId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="tp-native flex-1 bg-transparent text-sm font-mono-num outline-none border-0 p-0 disabled:cursor-not-allowed"
      />
      {/* Hide Chrome/Edge's default clock indicator so the lucide icon is the
          only clock affordance shown */}
      <style>{`
        .tp-native::-webkit-calendar-picker-indicator { display: none; -webkit-appearance: none; }
        .tp-native::-webkit-inner-spin-button { display: none; }
      `}</style>
    </div>
  );
}
